import { scopedStorage } from './userStorage';

const PREMIUM_PREFERENCE_KEY = 'prayer_guide_premium_preference';

export const getPremiumPreference = () => scopedStorage.getItem(PREMIUM_PREFERENCE_KEY) || 'explore';

export const setPremiumPreference = (preference) => {
    scopedStorage.setItem(PREMIUM_PREFERENCE_KEY, preference);
};

export const shouldShowPremiumPromotion = () => getPremiumPreference() !== 'free';

const premiumPreference = {
    getPremiumPreference,
    setPremiumPreference,
    shouldShowPremiumPromotion
};

export default premiumPreference;
